import { banOpenidLogin } from "@/api/role";
export default {
  props: {
    openId: String
  },
  data: function data() {
    return {
      hour: 60 * 60,
      day: 24 * 60 * 60,
      year: 365 * 24 * 60 * 60,
      serverList: {},
      formData: {
        open_id_list: [this.openId],
        time: 86400,
        ban_reason: ""
      }
    };
  },
  watch: {},
  methods: {
    banRole: function banRole() {
      var _this = this;
      // 检查输入时间是否有效，是否有超出范围
      var time = Math.round(this.formData.time);
      if (isNaN(time) || time < 0) {
        this.$message({
          type: "error",
          message: "封禁时间必须为正数"
        });
        return;
      }
      if (time > 50 * this.year) {
        this.$message({
          type: "error",
          message: "封禁时间不能超过50年"
        });
        return;
      }
      banOpenidLogin(this.formData).then(function (res) {
        if (res.code == 0) {
          _this.$emit("banFinish");
        }
      });
    },
    setTime: function setTime(seconds) {
      this.formData.time = String(seconds);
    },
    setBanReason: function setBanReason(data) {
      this.formData.ban_reason = data;
    }
  }
};